import React, { useRef, useState } from "react";
import { appConfigs } from "../../../martin/_helpers";
import CircularProgress from '@material-ui/core/CircularProgress';
// Reference: https://www.npmjs.com/package/react-google-recaptcha
import ReCAPTCHA from "react-google-recaptcha";
import { Formik } from "formik";
import * as Yup from "yup";
import Alert from '@material-ui/lab/Alert'; // https://material-ui.com/components/alert/#simple-alerts
import TextField from '@material-ui/core/TextField';
import { contactUs } from "../../../app/redux/authCrud";
import { PageTitle } from "../../../martin/_partials";

export default function Contact() {
    const [processing, setProcessing] = useState(false);
    const [alert, setAlert] = useState(null);
    const recaptchaRef = useRef({});

    const [initialValues, setInitialValues] = useState({
        name: "",
        email: "",
        message: "",
    });

    const contactSchema = Yup.object().shape({
        name: Yup.string().required(),
        email: Yup.string().email().min(5).max(250).required(),
        message: Yup.string().required(),
    });

    const onSubmitWithReCAPTCHA = async (values) => {
        // console.log(values);
        setProcessing(true);
        const captcha = await recaptchaRef.current.executeAsync();
        // console.log("Captcha value:", captcha);
        contactUs(values.email, values.name, values.message, captcha)
            .then((resp) => {
                // console.log(resp.data);
                if (resp.data.response_code === 1) {
                    setAlert({ type: 'success', msg: `Your message was successfully sent. I'll be in touch.` });
                    setProcessing(false);
                    setInitialValues({
                        name: "",
                        email: "",
                        message: "",
                    });
                } else {
                    setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                    setProcessing(false);
                }
            })
            .catch(() => {
                setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                setProcessing(false);
            });
    }

    return (
        <>
            <div className="martin-narrow-content content-section">
                <PageTitle heading={"Say Hello"} headingMeta={"Contact"} />
                <div className="row">
                    <div className="col-md-7 col-md-offset-3 col-md-pull-3">
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={contactSchema}
                            onSubmit={(values) => {
                                onSubmitWithReCAPTCHA(values);
                            }}>
                            {({ values, errors, touched, handleChange, handleSubmit, handleReset, setFieldValue, getFieldProps }) => {
                                return (
                                    <React.Fragment>

                                        {alert && <Alert onClose={() => setAlert(null)} severity={alert.type} style={{ marginBottom: '20px' }}><div dangerouslySetInnerHTML={{ __html: alert.msg }} /></Alert>}

                                        <div className="form-group"></div>
                                        <TextField
                                            autoFocus
                                            color="secondary"
                                            autoComplete="name"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            margin="dense"
                                            id="name"
                                            type="text"
                                            disabled={processing}
                                            error={Boolean(errors.name && touched.name)}
                                            // {...getFieldProps("name")}
                                            label="Name"
                                            helperText="Your name"
                                            fullWidth
                                        />
                                        <TextField
                                            color="secondary"
                                            autoComplete="email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            margin="dense"
                                            id="email"
                                            type="email"
                                            disabled={processing}
                                            error={Boolean(errors.email && touched.email)}
                                            // {...getFieldProps("email")}
                                            label="Email"
                                            helperText="Your email"
                                            fullWidth
                                        />
                                        <TextField
                                            color="secondary"
                                            autoComplete="message"
                                            name="message"
                                            value={values.message}
                                            onChange={handleChange}
                                            margin="dense"
                                            type="text"
                                            disabled={processing}
                                            error={Boolean(errors.message && touched.message)}
                                            // {...getFieldProps("message")}
                                            label="Message"
                                            helperText="Your message here"
                                            fullWidth
                                            multiline
                                        />
                                        <div className="form-group mt-2">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                size="invisible"
                                                sitekey={appConfigs.recaptcha_site_key}
                                            />
                                            <p>
                                                <small>Protected by reCAPTCHA, Google&nbsp;
                                                    <a href="https://www.google.com/intl/en/policies/privacy/" target="_blank" rel="noreferrer">Privacy Policy</a>&nbsp;&amp;&nbsp;
                                                    <a href="https://www.google.com/intl/en/policies/terms/" target="_blank" rel="noreferrer">Terms of Service</a> apply.
                                                </small>
                                            </p>
                                        </div>
                                        <div className="form-group">
                                            <button
                                                type="submit"
                                                onClick={handleSubmit}
                                                disabled={processing}
                                                className="btn btn-primary btn-send-message"
                                            >
                                                Send Message
                                                {processing && <CircularProgress
                                                    variant="indeterminate"
                                                    color={'inherit'}
                                                    size={16}
                                                    thickness={4}
                                                    style={{ marginLeft: '8px' }}
                                                />}
                                            </button>
                                        </div>
                                    </React.Fragment>
                                );
                            }}
                        </Formik>
                    </div>

                </div>
            </div>
        </>
    );
}